import { FETCH_FLEET_USER_GROUP_PRICING, DELETE_FLEET_USER_GROUP_PRICING, UPDATE_FLEET_USER_GROUP_PRICING, CREATE_FLEET_USER_GROUP_PRICING, GET_FLEET_USER_GROUP_PRICING } from 'actions/fleetPricing';
import { toast } from 'react-toastify';
import _ from 'lodash';

const initialState = {
  isLoading: false,
  fleetUserGroupPricing: [],
  fleetUserGroupPricingDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const fleetUserGroupPricingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_FLEET_USER_GROUP_PRICING.REQUEST:
    case DELETE_FLEET_USER_GROUP_PRICING.REQUEST:
    case FETCH_FLEET_USER_GROUP_PRICING.REQUEST:
    case CREATE_FLEET_USER_GROUP_PRICING.REQUEST:
    case GET_FLEET_USER_GROUP_PRICING.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_FLEET_USER_GROUP_PRICING.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        fleetUserGroupPricing: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case GET_FLEET_USER_GROUP_PRICING.SUCCESS: {
      return {
        ...state,
        fleetUserGroupPricingDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_FLEET_USER_GROUP_PRICING.SUCCESS: {
      toast.success('Fleet User Group Pricing added successfully');
      return {
        ...state,
        fleetUserGroupPricing: _.concat(state.fleetUserGroupPricing, payload),
        isLoading: false,
      };
    }

    case UPDATE_FLEET_USER_GROUP_PRICING.SUCCESS: {
      toast.success('Fleet User Group Pricing updated successfully');
      return {
        ...state,
        isLoading: false,
        fleetUserGroupPricing: state.fleetUserGroupPricing.map((data) => (data.id === payload.id ? payload : data)),
      };
    }

    case DELETE_FLEET_USER_GROUP_PRICING.SUCCESS: {
      toast.success('Fleet User Group Pricing deleted successfully');
      return {
        ...state,
        fleetUserGroupPricing: state.fleetUserGroupPricing.filter((data) => data.id !== payload),
      };
    }
    case DELETE_FLEET_USER_GROUP_PRICING.FAIL:
    case UPDATE_FLEET_USER_GROUP_PRICING.FAIL:
    case FETCH_FLEET_USER_GROUP_PRICING.FAIL:
    case CREATE_FLEET_USER_GROUP_PRICING.FAIL:
    case GET_FLEET_USER_GROUP_PRICING.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default fleetUserGroupPricingReducer;
